import { BlockType, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  getArrayTypeReducerGuard
} from "../reducers"

export type BlockRef = {
  type: BlockType
  id: string
}

const reducerAction = {
  type: actionCreatorTypeGuard<BlockRef, BlockType>("type", "BlockRef"),
  id: actionCreatorTypeGuard<BlockRef, string>("id", "BlockRef"),
  __record: actionCreatorTypeGuard<TypeArray, BlockRef>("BlockRef", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<BlockRef>>(
    "create",
    "__create/BlockRef"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof BlockRef
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockRefAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockRefReducer = reducerTypeGuard<BlockRef>()
  .case(...reducerAction.type)
  .case(...reducerAction.id)
  .build()
